<div class="wrapper">
    <div *ngIf="(isLoading$ | async)"
        class="spinner-wrapper">
        <mat-spinner [diameter]="25"></mat-spinner>
    </div>
    <app-empty-result *ngIf="!(isLoading$ | async) && !(products$ |async)?.length"></app-empty-result>
    <div class="sort-wrapper" *ngIf="!(isLoading$ | async) && (products$ |async)?.length">
        <ng-select [formControl]="orderControl">
            <ng-option *ngFor="let opt of orderOptions"
                [value]="opt.value">{{opt.name}}</ng-option>
        </ng-select>
    </div>
    <ng-container *ngIf="!(isLoading$ | async) && (products$ |async)?.length">
        <cdk-virtual-scroll-viewport 
            class="search-scrolled-view"
            [itemSize]="itemSize" 
            [style.height.px]="(products$ |async)?.length * itemSize">
            <div class="product-items-list">
                <div class="product-item" 
                    [style.max-height.px]="itemSize"
                    *cdkVirtualFor="let item of products$|async">
                    <div class="product-img">
                        <img [src]="getProductImage(item)"
                            alt="">
                    </div>
                    <div class="product-desc">
                        <div class="product-name-wrapper">
                            <span class="product-name">{{item.name}} |</span>
                            <span class="product-code"> {{item.productCode}}</span>
                        </div>
                        <div class="product-desc show-less">
                            <div [innerHtml]="item.description"
                                class="desc-text"></div>
                            <div (click)="triggerShowMore($event)"
                                class="show-more-btn">Show more</div>
                            <div (click)="triggerShowMore($event)"
                                class="show-less-btn">Show less</div>
                        </div>
                        <div class="product-info">
                            <div class="product-leadtime"><span class="title">Leadtime:
                                </span>{{item.leadTime}}
                            </div>
                            <div class="product-leadtime"><span class="title">Min. quantity:
                                </span>{{item.minQty}}</div>
                            <div class="product-leadtime"><span class="title">Min. price:
                                </span>{{item?.pricesFrom | currency:
                                'GBP'}}</div>
                        </div>
                    </div>
                    <div class="actions-wrapper">
                        <a (click)="redirectTo(item)"
                            class="link-wrapper">
                            <span>
                                Edit
                            </span>
                        </a>
                        <a (click)="redirectToPublicView(item)"
                            class="link-wrapper">
                            <svg-icon src="assets/images/redirect.svg"></svg-icon>
                            <span>
                                View on frontstore
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </cdk-virtual-scroll-viewport>
    </ng-container>
</div>
<!-- <div class="wrapper">
    <div class="product-item" *ngFor="let product of products$ | async">

    </div>
</div> -->